import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { Title } from './styles/Title';
import { Wrapper } from './styles/Wrapper';
import { Modal } from '@modals/core-ui/Modal';

type TProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const ASOneVideo = ({ isOpen, onClose }: TProps) => {
  return (
    <Modal isOpen={isOpen} onClose={() => onClose()}>
      <Wrapper>
        <Title style={{ margin: '0 0 25px', textAlign: 'center' }}>AutoScriptOne</Title>
        <iframe
          src="https://www.youtube.com/embed/L1AXh2P1LfM"
          name="myiFrame"
          scrolling="no"
          frameBorder="1"
          height="400px"
          width="600px"
          allowFullScreen
        ></iframe>
        <div style={{ marginTop: '20px' }}>
          <Button onClick={onClose}>Got it!</Button>
        </div>
      </Wrapper>
    </Modal>
  );
};
